import { LOADING_UI } from "../types";
import { db } from "../../firebase/firebase";
import store from "../store";
import { mapKV } from "../../utils/map";
import { getOrganizationRef } from "./utils";

export const editAppBundle = ({ key, name, description, selectedAppKeys, organizationKey, globalAccess }) => dispatch => {
    dispatch({ type: LOADING_UI, payload: true });
    const appRefs = [];
    selectedAppKeys.forEach(s => appRefs.push(db.doc("apps/" + s)));
    db.collection("contentBundles")
        .doc(key)
        .update({
            name,
            description,
            appRefs,
            organizationRef: getOrganizationRef(organizationKey),
            globalAccess
        });
};

export const addAppBundle = ({ name, description, selectedAppKeys, organizationKey, globalAccess }) => dispatch => {
    dispatch({ type: LOADING_UI, payload: true });
    const appRefs = [];
    selectedAppKeys.forEach(s => appRefs.push(db.doc("apps/" + s)));
    db.collection("contentBundles").add({
        name,
        description,
        appRefs,
        organizationRef: getOrganizationRef(organizationKey),
        globalAccess
    });
};

export const deleteAppBundle = bundleKey => dispatch => {
    dispatch({ type: LOADING_UI, payload: true });
    mapKV(store.getState().data.deviceGroups, (groupKey, { contentBundleRefs }) => {
        if (contentBundleRefs.find(s => s.id == bundleKey)) {
            db.collection("deviceGroups")
                .doc(groupKey)
                .update({
                    contentBundleRefs: contentBundleRefs.filter(s => s.id !== bundleKey)
                });
        }
    });
    db.collection("contentBundles")
        .doc(bundleKey)
        .delete();
};
